export enum LocalizationKey {
    Level = "lvl",
    LevelCompleted = "lvl_complete",
    LevelFailed = "lvl_failed",
    NoVegetablesLeft = "no_vegetables_left",
    MolesWon = "moles_won",
    Click = "click",
    Click3 = "click3",
    BuyCallToAction = "buy_call_to_action",
    ResetMessage = "reset_message",
    Yes = "yes",
    No = "no",
    ResetProgress = "reset_progress"
}

export enum Language {
    English = "en",
    French = "fr",
    Spanish = "es",
    German = "de",
    Italian = "it",
    Japanese = "ja",
    Russian = "ru",
    Czech = "cs",
    Polish = "pl"
}
